<div id='audio-guide-logo'>
    <img src='./assets/images/logo_audio_guide.png' alt/>
</div>

<style type='text/scss'>
    #audio-guide-logo {
        width: 40%;
        height: fit-content;
        position: relative;
        align-self: center;

        img {
            width: 100%;
        }
    }

    @media screen and (min-width:550px){
        #audio-guide-logo {
            width: 100%;
            max-height: 22vh;
            height: 22vh;

            img {
                height: 100%;
                object-fit: contain;
            }
        }
    }
</style>